import { render, staticRenderFns } from "./main-details-media.vue?vue&type=template&id=0d487e9e"
import script from "./main-details-media.vue?vue&type=script&lang=js"
export * from "./main-details-media.vue?vue&type=script&lang=js"
import style0 from "./main-details-media.vue?vue&type=style&index=0&id=0d487e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports